const {
  FIND,
  NPS: {
    NPS_WEB,
    NPS_BRAND,
  },
  GRADE: {
    OVERALL,
    GRAPHIC,
    GRAPHIC_VISUAL_IMPRESSION,
    STRUCTURE,
    STRUCTURE_SEARCH,
    STRUCTURE_MENU,
    STRUCTURE_PRODUCT_FINDER,
    INFORMATION,
    INFORMATION_PRODUCT,
    INFORMATION_CONTACT,
    USER_FRIENDLINESS,
    EXPECTATIONS,
  },
} = require('./questionCategories');

const BENCHMARK_CATEGORIES = [
  FIND,
  NPS_WEB,
  NPS_BRAND,
  OVERALL,
  GRAPHIC,
  GRAPHIC_VISUAL_IMPRESSION,
  STRUCTURE,
  STRUCTURE_SEARCH,
  STRUCTURE_MENU,
  STRUCTURE_PRODUCT_FINDER,
  INFORMATION,
  INFORMATION_PRODUCT,
  INFORMATION_CONTACT,
  USER_FRIENDLINESS,
  EXPECTATIONS,
];

const DISPLAYED_BENCHMARK_CATEGORIES = [
  FIND,
  NPS_WEB,
  NPS_BRAND,
  OVERALL,
  GRAPHIC,
  STRUCTURE,
  INFORMATION,
  USER_FRIENDLINESS,
  EXPECTATIONS,
];

module.exports = {
  BENCHMARK_CATEGORIES,
  DISPLAYED_BENCHMARK_CATEGORIES,
};
